module.exports = __webpack_public_path__ + "static/ART_LOGO-SYMBOL_Primary-ef7da27b5f1bc16a76742cc90b81e0af.svg";